seedWebApp.controller('PricesController', ['$scope', 'TranslationService', '$window', '$routeParams', '$location',
    function ($scope, TranslationService, $window, $routeParams, $location) {

        console.log('PricesController');

        //Controle tab selecionado
        $scope.selectedIndex = 0;
        $scope.selTab = $routeParams.Tab;

        $scope.tabSelected = function (page) {
            $location.search('Tab', page.pageIndex);
            $scope.selectedIndex = page.pageIndex;
        };

        $scope.defaultPages = [
            { pageIndex: 0, pageLabel: 'Cotações MBF',   pageDisplay: 'Prices/Prices', pageUrl: 'SPA/Prices/mbfPrices.html' },
            { pageIndex: 1, pageLabel: 'Adicionais MBF', pageDisplay: 'Prices/Prices', pageUrl: 'SPA/Prices/mbfAdditionals.html' },
            //{ pageIndex: 2, pageLabel: 'Preços', pageDisplay: 'Prices/Prices', pageUrl: 'SPA/Prices/Prices.html' },    
            { pageIndex: 2, pageLabel: 'Moedas', pageDisplay: 'Prices/Prices', pageUrl: 'SPA/Prices/currencies.html' },    
            //{ pageIndex: 4, pageLabel: 'Configuração Preços', pageDisplay: 'Prices/Prices', pageUrl: 'SPA/Prices/priceConfig.html' },            
        ];

        $scope.pages = $scope.defaultPages;

        $(document).ready(function () {
            $scope.overflowSize = $scope.AdjustSize();
        });

        $window.onresize = function () {
            $scope.overflowSize = $scope.AdjustSize();
        };

}]);